import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  ServiceCategoryCreateInput,
  ServiceCategoryDto,
  ServiceCategoryUpdateInput,
} from '@upme/contracts';
import { api } from '../../app/api-client';
import { serviceCategoriesKey, serviceCategoryByIdOptions } from './queries';

export function useCreateServiceCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ServiceCategoryCreateInput) =>
      api.post('admin/service-categories', { json: body }).json<ServiceCategoryDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...serviceCategoriesKey] }),
  });
}

export function useUpdateServiceCategory(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ServiceCategoryUpdateInput) =>
      api.patch(`admin/service-categories/${id}`, { json: body }).json<ServiceCategoryDto>(),
    onSuccess: (data) => {
      qc.setQueryData(serviceCategoryByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: [...serviceCategoriesKey] });
    },
  });
}

export function useDeleteServiceCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`admin/service-categories/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...serviceCategoriesKey] }),
  });
}
